import { TableBody, TableCell, TableRow } from "@mui/material";
import { TableHeaderItem } from "./TableHeader";
import { commonTableStyles as styles } from "./tableStyles";
import Loader from "components/loader";

interface TableProps {
  columns: TableHeaderItem[];
  data: Record<string, any>[];
  onItemPress?: Function;
  isLoading?: boolean;
}

export const TableContent = ({
  data,
  columns,
  onItemPress,
  isLoading = false,
}: TableProps) => {
  // console.log(
  //   "data in table body :",
  //   data,
  //   columns,
  //   onItemPress,
  //   (isLoading = false)
  // );
  if (isLoading) {
    return (
      <TableCell rowSpan={5} colSpan={columns.length} sx={{}}>
        <Loader />
      </TableCell>
    );
  }
  return (
    <TableBody>
      {data && data.length > 0 ? (
        data.map((value: Record<string, any>, i) => (
          <TableRow sx={{ ...styles.row }} key={i}>
            {columns.map((colItem, index) => (
              <TableCell
                key={index + ""}
                onClick={() => onItemPress && onItemPress()}
              >
                {value[colItem.id]}
              </TableCell>
            ))}
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell
            colSpan={columns.length}
            rowSpan={3}
            sx={{
              fontWeight: 600,
              fontSize: "1.5rem",
              lineHeight: "22px",
              textAlign: "center",
            }}
          >
            {"No Data Found"}
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  );
};
